"use client";

import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

const loaderVariants = cva("flex flex-col items-center justify-center gap-3", {
  variants: {
    size: {
      sm: "",
      md: "py-8",
      lg: "py-16",
      full: "min-h-[50vh]",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

const spinnerSizes = {
  sm: "h-5 w-5",
  md: "h-8 w-8",
  lg: "h-12 w-12",
  full: "h-12 w-12",
};

export interface LoaderProps extends VariantProps<typeof loaderVariants> {
  text?: string;
  className?: never;
}

export function Loader({ size = "md", text, className }: LoaderProps) {
  return (
    <div className={cn(loaderVariants({ size }), className)}>
      <Loader2
        className={cn(
          spinnerSizes[size || "md"],
          "animate-spin text-indigo-600 dark:text-indigo-400"
        )}
      />
      {text && (
        <p className="text-sm font-medium text-slate-600 dark:text-zinc-400">
          {text}
        </p>
      )}
    </div>
  );
}
